var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaflokKeySoftware(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Saflok_Key_Software"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Saflok_Key_Software",
    "data-name": "Saflok Key Software",
    clipPath: "url(#clip-Saflok_Key_Software)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "monitor_5034222",
    transform: "translate(-5.665 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M6.665,25.181V76.452A9.45,9.45,0,0,0,9.436,83.2a9.922,9.922,0,0,0,2.1,1.542,9.578,9.578,0,0,0,4.667,1.25H41.373l-2.729,5.375H31.353a2.083,2.083,0,1,0,0,4.167H79.207a2.083,2.083,0,0,0,0-4.167H71.915l-2.729-5.375H94.353a9.549,9.549,0,0,0,9.542-9.521V70.6c0-.021-.021-.021-.021-.042V25.2a9.549,9.549,0,0,0-9.521-9.542H78.228v3.563a9.4,9.4,0,0,1,1.5.6H94.353A5.37,5.37,0,0,1,99.707,25.2V68.514H10.832V25.181a5.348,5.348,0,0,1,5.333-5.354H30.852a9.79,9.79,0,0,1,1.458-.6V15.66H16.165a9.514,9.514,0,0,0-9.5,9.521Zm47.125,50h2.958a2.083,2.083,0,0,1,0,4.167H53.79a2.083,2.083,0,1,1,0-4.167Z",
    transform: "translate(0 10.465)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M43.374,6A18.823,18.823,0,0,0,24.583,24.792v8.625H23.353a5.717,5.717,0,0,0-5.708,5.708v29.4a5.717,5.717,0,0,0,5.708,5.708H63.416A5.7,5.7,0,0,0,69.1,68.521v-29.4a5.7,5.7,0,0,0-5.688-5.708h-1.25V24.792A18.809,18.809,0,0,0,43.374,6Zm9.6,43.5-11.6,11.583a2.035,2.035,0,0,1-1.458.625,2.082,2.082,0,0,1-1.479-.625l-4.646-4.646a2.075,2.075,0,0,1,0-2.938,2.038,2.038,0,0,1,2.937,0l3.188,3.167,10.1-10.1a2.1,2.1,0,0,1,2.958,0,2.075,2.075,0,0,1,0,2.938ZM58,33.417H28.749V24.792a14.625,14.625,0,1,1,29.25,0Z",
    transform: "translate(11.895 0)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaflokKeySoftware);
export default __webpack_public_path__ + "static/media/saflok-key-software.76d2c301b38238c7de83abf58ba066cc.svg";
export { ForwardRef as ReactComponent };